import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    column: { type: String, default: "" },
    direction: { type: String, default: "asc" }
  }

  sort(event) {
    const th = event.currentTarget
    const colIndex = th.cellIndex
    const tbody = this.element.querySelector("tbody")
    if (!tbody) return

    const rows = Array.from(tbody.querySelectorAll("tr"))
    const column = th.dataset.sortableTableColumnParam || String(colIndex)

    const dir = (this.columnValue === column && this.directionValue === "asc")
      ? "desc"
      : "asc"

    rows.sort((a, b) => {
      const aCell = a.cells[colIndex]
      const bCell = b.cells[colIndex]
      if (!aCell || !bCell) return 0

      const aVal = aCell.dataset.sortValue || aCell.textContent.trim()
      const bVal = bCell.dataset.sortValue || bCell.textContent.trim()
      const aNum = parseFloat(aVal.replace(/[^0-9.\-]/g, ""))
      const bNum = parseFloat(bVal.replace(/[^0-9.\-]/g, ""))

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return dir === "asc" ? aNum - bNum : bNum - aNum
      }
      return dir === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
    })

    rows.forEach(row => tbody.appendChild(row))
    this.columnValue = column
    this.directionValue = dir

    // Update sort indicators
    this.element.querySelectorAll("th").forEach(h => {
      h.classList.remove("sort-asc", "sort-desc")
    })
    th.classList.add(dir === "asc" ? "sort-asc" : "sort-desc")
  }
}
